import React, { useEffect, useId, useState } from "react";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InPlaceError from "components/in-place-error/InPlaceError";
import "./select.scss";


interface IOptions {
  options: string[];
  placeholder?: string;
  errorMessage?: string;
  onChange?: (e: string) => void;
  label?: string;
  className?: string;
  initialValue?: string;
  excludeFromTranslation?: boolean;
}  
export const Select = React.forwardRef(
  (
    {
      options,
      placeholder = "Select an option",
      errorMessage,
      className,
      onChange,
      label,
      initialValue = "",
      excludeFromTranslation = false,
}: IOptions,
    ref
  ) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(initialValue);
    const showError = !!errorMessage;
    const selectId = useId();
    const listId = `${selectId}-listbox`;

    useEffect(() => {
      setSelectedItem(initialValue);
    }, [initialValue]);

    const getClassName = (value: string) =>
      value !== "" ? "selectedItem" : "placeholder";

    return (
      <div className={`dropdown-container ${className ?? ""}`}>
        {label && (
          <div className="input-label__wrapper">
            <label htmlFor={selectId} className="input-label">
              {label}
            </label>
          </div>
        )}
        <div className="dropdown__wrapper">
          <button
            ref={ref as React.Ref<HTMLButtonElement>}
            type="button"
            id={selectId}
            className={showError ? "dropdown dropdown--error" : "dropdown"}
            onClick={() => setIsDropdownVisible((prev) => !prev)}
            aria-label={label ?? "Select an option"}
            aria-haspopup="true"
            aria-expanded={isDropdownVisible}
            aria-controls={listId}
          >
            <span className={`${getClassName(selectedItem)}${excludeFromTranslation ? " GlobalLinkNoTx" : ""}`}>              {selectedItem !== "" ? selectedItem : placeholder}
            </span>
            <span data-testid="up-down-icon" className="dropdown-icon">
              {isDropdownVisible ? (
                <FontAwesomeIcon icon={regular("chevron-up")} />
              ) : (
                <FontAwesomeIcon icon={regular("chevron-down")} />
              )}
            </span>
          </button>
          {isDropdownVisible && (
            <div className="dropdown-items" id={listId}>
              {options.map((item) => (
                <button
                  key={item}
                  type="button"
                  className={`select-item${excludeFromTranslation ? " GlobalLinkNoTx" : ""}`}
                  onClick={() => {
                    onChange?.(item);
                    setSelectedItem(item);
                    setIsDropdownVisible(false);
                  }}
                >
                  {item}
                </button>
              ))}
            </div>
          )}
          {showError && !isDropdownVisible && (
            <InPlaceError errorPhrase={errorMessage} />
          )}
        </div>
      </div>
    );
  }
);

Select.displayName = "Select";
